import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { LanguageService } from '../../../../../shared/modules/language/services/language.service';

export type Direction = 'ltr' | 'rtl';

@Injectable({
  providedIn: 'root'
})
export class DirectionService {
  direction$ = new BehaviorSubject<Direction>('ltr');

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private languageService: LanguageService
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.router.url),
        map(url => this.resolveDirection(url))
      )
      .subscribe((direction: Direction) => {
        this.document.dir = direction;
        this.direction$.next(direction);
      });
  }

  resolveDirection(url: string): Direction {
    const [
      language,
      page,
      identifier,
      _identifierId,
      subpage
    ] = this.languageService.getSegmentsFromUrl(url);

    if (language === 'ar') {
      // add specific page conditions like this
      if (
        this.languageService.isAdminPageFullyTranslated(page, identifier, subpage) ||
        this.languageService.isEsgPageFullyTranslated(page, identifier, subpage) ||
        !this.languageService.isUserScopePage(page)
      ) {
        return 'ltr';
      }

      return 'rtl';
    }

    return 'ltr';
  }
}
